import { Tabs } from '@src/components';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { USER_MANAGEMENT_FULL_URL } from '@src/constants/URLS.const';
import { usePermissions } from '@src/hooks';
import { MODULE_KEYS } from '@src/constants/permissions.const';

export default function UserManagement() {
    const navigate = useNavigate();
    const location = useLocation();
    const tabKey = location.pathname.split('/').pop();
    const path = location.pathname;
    const { permissionOf } = usePermissions();

    const handleTabChange = (key: string) => {
        navigate(`${USER_MANAGEMENT_FULL_URL}/${key}`);
    };

    const hideTabs = [
        /^\/dashboard\/user-management\/roles\/new$/,
        /^\/dashboard\/user-management\/roles\/[^/]+\/detail$/,
        /^\/dashboard\/user-management\/roles\/edit\/[^/]+$/,
    ].some((regex) => regex.test(path));

    const tabItems = [
        { key: 'users', label: 'Users', module: MODULE_KEYS.UserManagement },
        { key: 'roles', label: 'Roles', module: MODULE_KEYS.RoleManagement },
        {
            key: 'users-logs',
            label: 'Users Logs',
            module: MODULE_KEYS.ActivityLogManagement,
        },
    ].filter((tab) => permissionOf(tab.module));

    return (
        <>
            <>
                {!hideTabs && (
                    <Tabs
                        activeKey={tabKey}
                        onChange={handleTabChange}
                        items={tabItems}
                    />
                )}
                <div className="mt-4">
                    <Outlet />
                </div>
            </>
        </>
    );
}
